<template>
  <div id="app" >
    <router-view />
  </div>
</template>

<script>
import { httpService } from "./service/httpService.js";
export default {
  data() {
    return {};
  },

  mounted() {
    this.changeGray();
  },

  //  切换灰色背景
  methods: {
    async changeGray() {
      let dom = document.documentElement;
      let res = await httpService.getGray();
      if (res.code == 200) {
        if (res.result.webColorStatus) {
          dom.classList.add("gray");
        } else {
          dom.classList.remove("gray");
        }
      }
    },
  },
};
</script>
<style lang="less">
@import './assets/css/common.less';
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	// p {
	// 	margin-block-end: 0;
	// 	margin-block-start: 0;
	// }
  
/deep/.el-popup-parent--hidden {
    overflow: auto;
}
	a {
		text-decoration: none;
	}
	.fade-leave-to {
		display: none;
	}
	// [v-clock] {
	// 	display: none!important;
	// }
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>
